import React from 'react';
import './OdButton.scss';

const OdButton = ({ onClick = () => {}, href = '#', label }) => {
  return (
    <a className="odButton" href={href} onClick={onClick}>
      {label}
    </a>
  );
};

export default OdButton;
